import { themeV2 } from '@synoptic/ui-kit/theme-v2/vars.js';
import { style } from '@vanilla-extract/css';

export const streamRowLinkV2 = style({
  color: 'inherit',
  textDecoration: 'none',
  minWidth: 0,
  selectors: {
    '&::after': {
      content: '',
      position: 'absolute',
      inset: 0,
      zIndex: 1,
    },
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    '&:focus-visible::after': {
      outline: `2px solid ${themeV2.color.border.focus}`,
      outlineOffset: '-1px',
    },
  },
});
